module.exports = __webpack_public_path__ + "img/hair_front_female_hairline.fc2043c4.png";